//* Libraries imports
import React from "react";
import { Container } from "@mui/material";

//* Components Imports
import ScrollTransition from "components/ScrollTransition";

//* Styles Imports
import styles from "./styles.module.css";

function ZeroInvestmentSection() {
  return (
    <section
      id="zero-investment-section"
      data-testid="zero-investment-section"
      aria-label="Seção informativa sobre a taxa única de dois por cento de investimento"
      className={styles.zeroInvestmentSection}
    >
      <Container
        id="zero-investment-container"
        data-testid="zero-investment-container"
        aria-label="Container do investimento zero"
        maxWidth="xl"
      >
        <ScrollTransition
          id="zero-investment-title-transition"
          data-testid="zero-investment-title-transition"
          aria-label="Animação do título investimento zero"
        >
          <h2
            id="zero-investment-title"
            data-testid="zero-investment-title"
            aria-label="Título: Investimento Zero"
            className={styles.sectionTitle}
          >
            <span
              id="zero-investment-gold"
              data-testid="zero-investment-gold"
              aria-label="INVESTIMENTO"
              className={styles.goldText}
            >
              INVESTIMENTO{" "}
            </span>
            <span
              id="zero-investment-white"
              data-testid="zero-investment-white"
              aria-label="ZERO"
              className={styles.textContrast}
            >
              ZERO
            </span>
          </h2>
          <div
            id="zero-investment-divider"
            data-testid="zero-investment-divider"
            aria-label="Linha decorativa do investimento zero"
            className={styles.divider}
          />
        </ScrollTransition>

        <ScrollTransition
          id="zero-investment-content-transition"
          data-testid="zero-investment-content-transition"
          aria-label="Animação do conteúdo da taxa e descrição"
          delay={200}
        >
          <div
            id="zero-rate-container"
            data-testid="zero-rate-container"
            aria-label="Destaque da taxa única de dois por cento"
            className={styles.rateContainer}
          >
            <div
              id="zero-rate-giant"
              data-testid="zero-rate-giant"
              aria-label="Dois por cento"
              className={styles.rateGiant}
            >
              2%
            </div>
            <div
              id="zero-rate-subtitle"
              data-testid="zero-rate-subtitle"
              aria-label="Taxa única por venda"
              className={styles.rateSubtitle}
            >
              TAXA ÚNICA POR VENDA
            </div>
          </div>

          <div
            id="zero-description-container"
            data-testid="zero-description-container"
            aria-label="Textos explicativos da taxa única"
            className={styles.zeroDescContainer}
          >
            <p
              id="zero-desc-1"
              data-testid="zero-desc-1"
              aria-label="Explicação: O lojista paga apenas 2% do valor da venda (descontado na transação)."
              className={styles.zeroDescText}
            >
              O lojista paga apenas{" "}
              <span
                className={styles.highlight}
                id="zero-desc-1-rate"
                data-testid="zero-desc-1-rate"
                aria-label="Taxa de 2 por cento"
              >
                {" "}
                2% do valor da venda{" "}
              </span>{" "}
              (descontado na transação).
            </p>
             <p
              id="zero-desc-2"
              data-testid="zero-desc-2"
              aria-label="Destinação: Este valor é reinvestido 100% em Marketing e Melhorias Tecnológicas para atrair mais clientes para sua loja."
              className={styles.zeroDescText}
            >
              Este valor é reinvestido 100% em <span className={styles.highlight}>Marketing</span> e <span className={styles.highlight}>Melhorias Tecnológicas</span> para atrair mais clientes para sua loja.{" "}
            </p>
            <button
              id="zero-cta-btn"
              data-testid="zero-cta-btn"
              aria-label="Botão para acessar o painel"
              onClick={() => window.open("https://painel.igoob.com.br", "_blank", "noopener,noreferrer")}
              className={styles.ctaButton}
              style={{ marginTop: "2.5rem" }}
            >
              Cadastre sua loja agora
            </button>
          </div>
        </ScrollTransition>
      </Container>
    </section>
  );
}

export default ZeroInvestmentSection;
